import React,
{
    useRef,
	useState
}
from "react";

import
{
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import
{
    faChevronUp,
    faChevronDown,
	faAnglesUp
}
from "@fortawesome/free-solid-svg-icons";

export default function ScrollableList(
{
    children,
    height = "300px"
})
{
    const contentRef =
        useRef(null);
		
		const [showTopButton, setShowTopButton] =
		    useState(false);

    function scrollUp()
    {
        if(!contentRef.current)
        {
            return;
        }

        contentRef.current.scrollBy(
        {
            top: -200,
            behavior: "smooth"
        });
    }

    function scrollDown()
    {
        if(!contentRef.current)
        {
            return;
        }

        contentRef.current.scrollBy(
        {
            top: 200,
            behavior: "smooth"
        });
    }
	
	function scrollTop()
	{
	    if(!contentRef.current)
	    {
	        return;
	    }

	    contentRef.current.scrollTo(
	    {
	        top: 0,
	        behavior: "smooth"
	    });
	}
	
	function handleScroll()
	{
	    if(!contentRef.current)
	    {
	        return;
	    }

	    setShowTopButton(
	        contentRef.current.scrollTop > 100
	    );
	}

    return (

        <div>

            <div
                style={{
                    textAlign: "right",
                    marginBottom: "8px"
                }}
            >
			
			{
			    showTopButton &&
			    (
					<FontAwesomeIcon
					    icon={faAnglesUp}
					    onClick={scrollTop}
					    style={{
					        cursor: "pointer",
					        color: "#5a9bd6",
					        marginRight: "12px"
					    }}
					/>
			    )
			}

                <FontAwesomeIcon
                    icon={faChevronUp}
                    onClick={scrollUp}
                    style={{
                        cursor: "pointer",
                        color: "#5a9bd6",
                        marginRight: "12px"
                    }}
                />

                <FontAwesomeIcon
                    icon={faChevronDown}
                    onClick={scrollDown}
                    style={{
                        cursor: "pointer",
                        color: "#5a9bd6"
                    }}
                />

            </div>

            <div
                ref={contentRef}
				onScroll={handleScroll}
                style={{
                    height: height,
                    overflow: "hidden"
                }}
            >

                {children}

            </div>

        </div>

    );
}